import axios from "@/api/index";
let method = 'GET';
/*密码登录*/
export const pws=data=>axios.post('/register/login/pws',data)
/*短信登录*/
export const sms=data=>axios.post('/register/login/sms',data)
/*云官网获取登录二维码*/
export const cloudWebsiteLoginQrCode=data=>axios.get('/register/login/cloudWebsiteLoginQrCode',data)
/*pc短信登录*/
export const pcSms=data=>axios.post('/register/login/pcSms',data)
/*二维码app身份授权*/
export const appQRAuthentication=data=>axios.post('/register/login/appQRAuthentication',data)
/*获取二维码*/
export const getQrCode=data=>axios.get('/register/login/getQrCode',data)
/*店铺登录*/
export const shopLogin=data=>axios.post('/register/login/shopLogin',data)
/*店铺找回密码*/
export const updatePassword=data=>axios.post('/register/login/updatePassword',data)
/*查询二维码登录状态*/
export const pollingLoginState=data=>axios.post('/register/login/pollingLoginState',data)
/*保存注册信息*/
export const registerSave=data=>axios.post('/register/save',data)
/*检查手机号是否注册*/
export const verifyMoblie=data=>axios.post('/register/verifyMoblie',data)
